import { render } from "./NavbarThree.vue?vue&type=template&id=404b2406&ts=true"
import script from "./NavbarThree.vue?vue&type=script&lang=ts"
export * from "./NavbarThree.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__